import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { FaLock } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { useState, useEffect } from "react";
import Header from "../Header.js";
import useUser from "../../hook/useUser"
import api from "../../api/axios";

const GeneralTraining = () => {
    const navigate = useNavigate();
    const { user } = useUser();
    const [training, setTraining] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const completedSections = user?.modules?.generalTraining?.preJobPreparation?.completedSections || [];

    useEffect(() => {
      if (!user || !user.employeeId) return;
      
      const fetchTraining = async () => {
        try {
                    const response = await api.get(`/api/employee/${user.employeeId}/training`);
                    setTraining(response.data);
        } catch(err) {
          console.error(err);
        }
      };
      fetchTraining();
    }, [user]);

        return (
        <>
            <div className="dashboard-wrapper">
                <Header />
                {/* dashboardに戻る */}
                <div onClick={() => navigate('/dashboard')} style={{ cursor: "pointer" }} className="nav_title">
                    <IoIosArrowBack className="fa-chevron-left"/>
                    Your Progress
                </div>

                {/* <h2>{user ? user.modules.generalTraining.preJobPreparation?.title : "Loading..."}</h2> */}

                <div className="card">
                    <div className="card-header" onClick={() => setIsOpen(!isOpen)} tyle={{ cursor: "pointer" }}>
                        <h2>{user ? user.modules.generalTraining.preJobPreparation?.title : "Loading..."}</h2>
                        {/* <FaChevronDown className="fa-chevron-down"/> */}
                        {isOpen ? (
                            <FaChevronUp className="fa-chevron-up" />
                            ) : (
                            <FaChevronDown className="fa-chevron-down" />
                        )}
                    </div>
                    {isOpen && (
                    <div className="items" id="items">
                        <div className="pulldown-each">
                            <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation", { state: { openCard: "uniform" } })}
                            style={{ cursor: "pointer" }}>
                                {user ? user.modules.generalTraining.preJobPreparation.uniform?.title : "Loading..."}
                            </h3>
                            {completedSections.includes("uniform") && (
                                <img src="/images/checkmark-done.png" className="checkmark-done" alt="done" />
                            )}
                        </div>
                        <div className="pulldown-each">
                            <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation", { state: { openCard: "onboardingProcess" } })}
                            style={{ cursor: "pointer" }}>
                                {user ? user.modules.generalTraining.preJobPreparation.onboardingProcess?.title : "Loading..."}
                            </h3>
                            {completedSections.includes("onboardingProcess") && (
                                <img src="/images/checkmark-done.png" className="checkmark-done" alt="done" />
                            )}
                        </div>
                        <div className="pulldown-each">
                            <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation", { state: { openCard: "timeTracking" } })}
                            style={{ cursor: "pointer" }}>
                                {user ? user.modules.generalTraining.preJobPreparation.timeTracking?.title : "Loading..."}
                            </h3>
                            {completedSections.includes("timeTracking") && (
                                <img src="/images/checkmark-done.png" className="checkmark-done" alt="done" />
                            )}
                        </div>
                        <div className="pulldown-each">
                            <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation", { state: { openCard: "educationRequirements" } })}
                            style={{ cursor: "pointer" }}>
                                {user ? user.modules.generalTraining.preJobPreparation.educationRequirements?.title : "Loading..."}
                            </h3>
                            {completedSections.includes("educationRequirements") && (
                                <img src="/images/checkmark-done.png" className="checkmark-done" alt="done" />
                            )}
                        </div>
                    </div>
                    )}
                </div>

                <div className="card-text-only">
                    <h2>{user ? user.modules.generalTraining.basicSkills?.title : "Loading..."}</h2>
                    <FaLock className="fa-lock"/>
                </div>
                <div className="card-text-only">
                    <h2>{user ? user.modules.generalTraining.brekaCulture?.title : "Loading..."}</h2>
                    <FaLock className="fa-lock"/>
                </div>

            </div>
        </>
    );
}

export default GeneralTraining;